import React from 'react'

function Routes() {
    return <></>
  }
 
  Routes.global = {
    url_login: 'https://manager-ads.com/ApiAliraweb.com/auth/'
  };
  
  export default Routes;
